import { initialState } from "../configuration.slice";

const resetConfig = () => {
    return initialState;
}

export default resetConfig;